import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";

@Injectable({
    providedIn: 'root'
})
export class DashboardGuard  {

    constructor(private oauthService: OAuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot) {
        const hasIdToken = this.oauthService.hasValidIdToken();
        const hasAccessToken = this.oauthService.hasValidAccessToken();
        if (hasIdToken && hasAccessToken)
            return true;

        this.router.navigateByUrl('/login');
    }
}
